const headers = [
  {
    text: 'common.input_title',
    value: 'title',
    sortable: true,
    width: '34%'
  },
  {
    text: 'common.input_content',
    value: 'body',
    sortable: true,
    width: '44%'
  },
  {
    text: 'common.input_sort-number',
    value: 'sortNumber',
    sortable: true,
    width: '9%'
  },
  {
    text: 'payment.payment_operation',
    value: 'editAndDelete',
    sortable: false,
    width: '13%'
  }
]
export default { headers }
